import { combineReducers } from "redux";

import loginReducer from "./login";
import invoiceReducer from "./invoice";
import orderReducer from "./order";
import userReducer from "./user";
import desktopReducer from "./desktop-menu";
import statusReducer from './status';
import economicGroupReducer from './economic-group';
import trainingReducer from './training';
import videoReducer from './video';
import accessReducer from './access';
import vouchersReducer from './vouchers';
import employeeReducer from './employee';
import rolesReducer from './roles';
import orderEditReducer from './edit-order';
import challengesReducer from './lapidar/challenges';
import branchCode from './lapidar/code';
import npsReducer from './nps';
import faqReducer from './faq';
import notificationReducer from './notification';
import logisticReducer from './logistic'
import classificationReducer from './lapidar/classification';
import pointsReducer from './lapidar/points';
import logisticPaymentReducer from './logistic-payment'
import stepsReducer from '../auth/steps'
import tokenReducer from '../auth/token'
import invalidCodeReducer from '../auth/invalidCode'



export const reducers = combineReducers({
  loginReducer,
  invoiceReducer,
  userReducer,
  orderReducer,
  desktopReducer,
  statusReducer,
  economicGroupReducer,
  trainingReducer,
  videoReducer,
  accessReducer,
  vouchersReducer,
  employeeReducer,
  rolesReducer,
  orderEditReducer,
  classificationReducer,
  challengesReducer,
  npsReducer,
  pointsReducer,
  faqReducer,
  notificationReducer,
  logisticReducer,
  logisticPaymentReducer,
  branchCode,
  stepsReducer,
  tokenReducer,
  invalidCodeReducer
});
